import { render } from "./bank-card.vue?vue&type=template&id=c83273c8"
import script from "./bank-card.vue?vue&type=script&lang=js"
export * from "./bank-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__